// src/layouts/DashboardLayout.tsx — Authenticated dashboard (auth guard + sidebar)
import { Outlet, Link } from "react-router-dom";
import { useAuth, useSessionKeepAlive } from "@/hooks/useAuth";
import { DashboardShell } from "@/components/dashboard";
import LoginForm from "@/components/LoginForm";
import { Spinner } from "@/components/ui";
import "@/components/dashboard/dashboard-skin.css";

export default function DashboardLayout() {
  const { isAuthenticated, isLoading, isInitialized, sessionExpired } = useAuth();

  // Keep session alive while user is on dashboard (refreshes tokens every 30 min)
  useSessionKeepAlive();

  // Show loading state while checking auth
  if (!isInitialized || isLoading) {
    return (
      <div className="dash-skin h-screen flex flex-col bg-background">
        <header className="flex items-center h-14 px-6 border-b border-neutral-subtle bg-surface">
          <Link to="/">
            <img
              src="/logo-horiz-color-transparent.png"
              alt="FHIRfly"
              width={120}
              height={28}
            />
          </Link>
        </header>
        <main className="flex-1 flex justify-center items-center">
          <Spinner size="lg" />
        </main>
      </div>
    );
  }

  // Show inline login form if not authenticated
  if (!isAuthenticated) {
    return (
      <div className="dash-skin h-screen flex flex-col bg-background">
        <header className="flex items-center h-14 px-6 border-b border-neutral-subtle bg-surface">
          <Link to="/">
            <img
              src="/logo-horiz-color-transparent.png"
              alt="FHIRfly"
              width={120}
              height={28}
            />
          </Link>
        </header>
        <LoginForm redirectTo="/dashboard" sessionExpired={sessionExpired} />
      </div>
    );
  }

  // Authenticated - show full dashboard with collapsible sidebar
  return (
    <DashboardShell>
      <Outlet />
    </DashboardShell>
  );
}
